var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Modal from "bootstrap-vue/es/components/modal/modal";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import ImageCropper from "../Components/ImageCropper.vue";
import FileUpload from "../Components/FileUpload.vue";
var ImageEditor = /** @class */ (function (_super) {
    __extends(ImageEditor, _super);
    function ImageEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localUrl = _this.url || null;
        _this.localBytes = _this.bytes || null;
        _this.localCrop = _this.crop || null;
        _this.localFileName = _this.fileName || null;
        return _this;
    }
    ImageEditor.prototype.show = function () {
        this.$refs.modal.show();
    };
    ImageEditor.prototype.hide = function () {
        this.$refs.modal.hide();
    };
    ImageEditor.prototype.onChange = function (ev) {
        this.$emit("change", ev);
    };
    ImageEditor.prototype.onShow = function (ev) {
        this.$emit("show", ev);
    };
    ImageEditor.prototype.onShown = function (ev) {
        this.$emit("shown", ev);
    };
    ImageEditor.prototype.onHide = function (ev) {
        this.$emit("hide", ev);
    };
    ImageEditor.prototype.onHidden = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$emit("hidden", ev);
                        return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageEditor.prototype.onOk = function (ev) {
        this.$emit("update:bytes", this.localBytes);
        this.$emit("update:crop", this.localCrop);
        this.$emit("update:fileName", this.localFileName);
        this.$emit("ok", ev);
    };
    ImageEditor.prototype.onCancel = function (ev) {
        this.$emit("cancel", ev);
    };
    ImageEditor.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.localUrl = this.url || null;
                        this.localBytes = this.bytes || null;
                        this.localCrop = this.crop || null;
                        this.localFileName = this.fileName || null;
                        return [4 /*yield*/, Vue.nextTick()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$refs.cropper.reset()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String, default: "Edit Image" })
    ], ImageEditor.prototype, "title", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ImageEditor.prototype, "enableUpload", void 0);
    __decorate([
        Prop({ type: String })
    ], ImageEditor.prototype, "borderRadius", void 0);
    __decorate([
        Prop({ type: Number, required: true })
    ], ImageEditor.prototype, "width", void 0);
    __decorate([
        Prop({ type: Number, required: true })
    ], ImageEditor.prototype, "height", void 0);
    __decorate([
        Prop({ type: String })
    ], ImageEditor.prototype, "url", void 0);
    __decorate([
        Prop({ type: String })
    ], ImageEditor.prototype, "bytes", void 0);
    __decorate([
        Prop({ type: Object })
    ], ImageEditor.prototype, "crop", void 0);
    __decorate([
        Prop({ type: String })
    ], ImageEditor.prototype, "fileName", void 0);
    ImageEditor = __decorate([
        Component({
            name: "ImageEditor",
            components: {
                Modal: Modal,
                "b-row": Row,
                "b-col": Col,
                ImageCropper: ImageCropper,
                FileUpload: FileUpload
            }
        })
    ], ImageEditor);
    return ImageEditor;
}(Vue));
export default ImageEditor;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/ImageEditor.vue
// module id = 873
// module chunks = 6